@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="pagehd ml-2">MCAP Partner Workshop Access List</div>
<form [formGroup]="programForm">
  <div class="ui-g workshop-header">
    <div class="ui-g-12 ui-md-12 ui-lg-12 title">Program</div>
    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <p-select
        [options]="programTypeList"
        placeholder="--Select Program--"
        optionLabel="programName"
        formControlName="programType"
        (onChange)="onProgramTypeSelect()"></p-select>
    </div>
  </div>
</form>
<form [formGroup]="partnerWorkshopForm">
  <div class="ui-g workshop-header">
    <div class="ui-g-12 ui-md-12 ui-lg-12 title">Workshop name</div>
    <div class="ui-g-12 ui-md-3 ui-lg-3">
      <p-select
        [options]="partnerEventDropdownList"
        placeholder="--Select Partner workshop--"
        optionLabel="eventName"
        formControlName="partnerWorkshopType"
        (onChange)="onWorkshopTypeSelect()"
        [disabled]="isDropdownDisabled">
      </p-select>
    </div>
  </div>
</form>
<app-partner-upload-history
  #uploadHistory
  (refreshList)="onWorkshopTypeSelect()"></app-partner-upload-history>
